/**
 *  角色管理相关接口
 */
import { axios } from '@/utils/request'

// 分页查询角色列表数据
export function queryRolePage (parameter) {
  return axios({
    url: '/sys/role/query',
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 查询所有可用角色列表
export function roleList () {
  return axios({
    url: '/sys/role/list',
    method: 'get'
  })
}

// 读取角色详情
export function getRoleDetail (id) {
  return axios({
    url: `/sys/role/${id}`,
    method: 'get'
  })
}

// 添加角色信息
export function addRole (parameter) {
  return axios({
    url: '/sys/role',
    method: 'post',
    data: parameter
  })
}

// 修改角色信息
export function updateRole (id, parameter) {
  return axios({
    url: `/sys/role/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
export function deleteRole (parameter) {
  return axios({
    url: `/sys/role`,
    method: 'delete',
    params: parameter
  })
}

// 修改启用状态
export function changeEnabled (id, parameter) {
  return axios({
    url: `/sys/role/${id}/changeEnabled`,
    method: 'patch',
    data: parameter
  })
}
